import styled from 'styled-components';
import { Flex } from './Flex';
import { Radio } from './Radio';

const RadioList = styled(Flex).attrs(() => ({
  direction: 'row',
  spacing: ['small', 'small'],
}))``;

const RadioListItem = styled(Radio)`
  flex: 1;
`;

export { RadioList, RadioListItem };
